import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';

export const DailyRunSummaryModule = new Module({
  id: 'daily-run-summary',
  name: 'Daily Run',
  path: 'daily-run-summary',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/DailyRunSummary'))
  )
});
